import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { ContentDocument, ContentDocumentGroup } from "@obg/ngx.core.content";
import { head } from "lodash-es";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { LoyaltyContentConfig } from "./loyalty-content.config";
import {
	LoyaltyEarnPoints,
	LoyaltyEarnPointsItem,
	LoyaltyEarnPointsResponse,
	LoyaltyMemberLevel,
	LoyaltyMemberLevelResponse,
} from "./loyalty-content.model";

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue.GetLoyaltyContentMemberLevels and AccountAppValue.GetLoyaltyContentEarnPoints instead
 */
export class LoyaltyContentService {
	constructor(
		private client: CoreHttpClient,
		private config: LoyaltyContentConfig
	) {}
	/**
	 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue.GetLoyaltyContentMemberLevels instead
	 */
	getMemberLevels(): Observable<LoyaltyMemberLevel[]> {
		return this.client
			.get<ContentDocumentGroup<LoyaltyMemberLevelResponse>>({
				url: this.config.getMemberLevelsEndpoint(),
			})
			.pipe(
				map((memberLevelsResponse) => {
					const rawMemberLevels = memberLevelsResponse.documents.loyaltyMemberLevel;

					return rawMemberLevels
						? rawMemberLevels.map((rawMemberLevel) => this.processRawMemberLevel(rawMemberLevel))
						: [];
				})
			);
	}
	/**
	 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue.GetLoyaltyContentEarnPoints instead
	 */
	getEarnPoints(): Observable<LoyaltyEarnPoints> {
		return this.client
			.get<ContentDocumentGroup<LoyaltyEarnPointsResponse>>({
				url: this.config.getEarnPointsEndpoint(),
			})
			.pipe(
				map((earnPointsResponse) => {
					const earnPoints: LoyaltyEarnPoints = {};
					const rawEarnPoints = earnPointsResponse.documents.loyaltyEarnPoints;

					if (rawEarnPoints) {
						for (const rawEarnPointsItem of rawEarnPoints) {
							const product = head(rawEarnPointsItem.content.metadata.product)!;

							if (!earnPoints[product]) {
								earnPoints[product] = [];
							}

							earnPoints[product].push(this.processRawEarnPointsItem(rawEarnPointsItem));
						}
					}

					return earnPoints;
				})
			);
	}

	private processRawMemberLevel(item: ContentDocument<LoyaltyMemberLevelResponse>): LoyaltyMemberLevel {
		return {
			name: head(item.content.name)!,
			minPoints: head(item.content.minPoints)!,
			multiplier: head(item.content.multiplier)!,
			rewardPointsDescription: head(item.content.rewardPointsDescription)!,
			imageUrl: head(item.content.image)!.url,
		};
	}

	private processRawEarnPointsItem(item: ContentDocument<LoyaltyEarnPointsResponse>): LoyaltyEarnPointsItem {
		return {
			description: head(item.content.description)!,
			earning: head(item.content.earning)!,
		};
	}
}
